import React from 'react';
import css from './css.less';

interface IProps {
  options: string[];
  onClick(color: string): void;
}

const Options = (props: IProps) => {
  const { options, onClick } = props;
  return (
    <div className={css.container}>
      {options.map((color, index) => {
        return (
          <div
            key={color}
            className={css.option}
            style={{
              background: color,
              marginRight: index === options.length - 1 ? 0 : 8,
            }}
            onClick={() => {
              onClick(color);
            }}
          />
        );
      })}
    </div>
  );
};
export default Options;
